<template>
  <div class="shop-screen cart-screen">
    <header class="shop-header">
      <button
        class="back"
        @click="$router.back()"
      >
        <van-icon name="arrow-left" />
      </button>
      <h1>{{ $t('shop.cart') }}</h1>
    </header>
    <main class="cart-list">
      <article
        v-for="item in list"
        :key="item.id"
        class="cart-card"
      >
        <button
          class="check"
          :class="{ checked: selected.indexOf(item.id) > -1 }"
          :disabled="!item.available"
          @click="toggle(item.id)"
        >
          ✓
        </button>
        <button
          type="button"
          class="product-image"
          :disabled="!item.available"
          @click="toggle(item.id)"
        >
          <img
            :src="item.product.image"
            :alt="item.product.title"
          >
        </button>
        <div class="cart-info">
          <button
            type="button"
            class="product-title"
            :disabled="!item.available"
            @click="toggle(item.id)"
          >
            {{ item.product.title }}
          </button>
          <del v-if="item.product.market_price">{{ money(item.product.market_price) }}</del>
          <strong>{{ money(item.product.price) }}</strong>
          <span>x{{ item.quantity }}</span>
        </div>
        <button
          class="remove"
          @click="remove(item.id)"
        >
          ×
        </button>
      </article>
      <van-empty
        v-if="empty"
        :description="$t('orders.noOrders')"
      />
    </main>
    <footer class="cart-actions">
      <div>{{ $t('shop.total') }}({{ selected.length }}) <strong>{{ money(total) }}</strong></div>
      <button
        :disabled="submitting || !selected.length"
        @click="confirm"
      >
        <van-icon
          name="bag-o"
          class="confirm-icon"
        />
        {{ $t('shop.confirmPurchase') }}
      </button>
      <a @click="$router.push('/goodList')">{{ $t('shop.continueShopping') }} &gt;</a>
    </footer>
  </div>
</template>

<script>
import Fetch from '@/utils/fetch';
import { addPen, multiplyPen } from '@/utils/money';
import Vue from 'vue';
import { Empty } from 'vant';

Vue.use(Empty);

export default {
    data() {
        return { list: [], selected: [], submitting: false, loading: false, empty: false };
    },
    computed: {
        total() {
            return this.list.filter((item) => this.selected.indexOf(item.id) > -1)
                .reduce((sum, item) => addPen(sum, multiplyPen(item.product.price, item.quantity)), '0');
        }
    },
    mounted() {
        this.$parent.footer('cart');
        this.load();
    },
    methods: {
        money(value) {
            return this.$formatPen(value);
        },
        load() {
            this.loading = true;
            Fetch('/shop/cartList', {}, null, true).then((res) => {
                this.list = res.data.list || [];
                this.selected = this.selected.filter((id) => this.list.some((item) => item.id === id));
                this.empty = this.list.length === 0;
            }).finally(() => {
                this.loading = false;
            });
        },
        toggle(id) {
            const item = this.list.find((entry) => entry.id === id);
            if (!item || !item.available) return;

            const index = this.selected.indexOf(id);
            if (index > -1) this.selected.splice(index, 1);
            else this.selected.push(id);
        },
        remove(id) {
            Fetch('/shop/cartRemove', { cart_id: id }, null, true).then(() => this.load());
        },
        confirm() {
            if (this.submitting || !this.selected.length) return;
            this.submitting = true;
            Fetch('/shop/orderFromCart', {
                cart_ids: this.selected,
                request_id: 'cart_' + Date.now() + '_' + Math.random().toString(36).slice(2, 12)
            }, null, true).then((res) => {
                this.$router.replace('/shopOrder/' + res.data.id);
            }).finally(() => {
                this.submitting = false;
            });
        }
    }
};
</script>

<style scoped>
.shop-screen { min-height: 100vh; background: #f5f5f5; padding-bottom: calc(144px + var(--app-bottom-menu-gap) + env(safe-area-inset-bottom, 0px)); color: #333; }
.shop-header { height: 50px; display: flex; position: relative; align-items: center; justify-content: center; background: #fff; border-bottom: 1px solid #eee; }
.shop-header h1 { margin: 0; color: #333; font-size: 16px; font-weight: 500; }
.back { position: absolute; left: 16px; border: 0; background: transparent; color: #ee4d2d; font-size: 18px; }
.cart-list { padding: 10px 0; }
.cart-card { display: flex; min-height: 118px; margin-bottom: 10px; align-items: center; gap: 10px; padding: 12px 14px; border-radius: 0; background: #fff; box-shadow: none; }
.check { flex: 0 0 22px; width: 22px; height: 22px; border: 1px solid #ccd1d7; border-radius: 50%; background: #fff; color: transparent; font-size: 12px; line-height: 12px; }
.check.checked { border-color: #ee4d2d; background: #ee4d2d; color: #fff; }
.product-image { flex: 0 0 74px; width: 74px; height: 96px; padding: 0; border: 0; background: transparent; cursor: pointer; }
.product-image img { display: block; width: 100%; height: 100%; object-fit: contain; }
.cart-info { flex: 1; min-width: 0;line-height: 16px; }
.product-title { display: -webkit-box; width: 100%; margin: 0 0 5px; padding: 0; overflow: hidden; border: 0; background: transparent; color: #333; font: inherit; font-size: 13px; line-height: 18px; text-align: left; cursor: pointer; -webkit-box-orient: vertical; -webkit-line-clamp: 3; }
.product-image:disabled, .product-title:disabled { cursor: default; opacity: .55; }
.cart-info del, .cart-info strong, .cart-info span { display: block; }
.cart-info del { color: #8a8f96; font-size: 10px; }
.cart-info strong { color: #ee4d2d; font-size: 14px; font-weight: 600; }
.cart-info span { margin-top: 2px; color: #000; font-size: 12px; }
.remove { padding: 4px; border: 0; background: transparent; color: #98a1aa; font-size: 30px; }
.cart-actions { position: fixed; z-index: 9; right: 0; bottom: var(--app-bottom-menu-height); left: 0; padding: 14px 16px 10px; background: #fff; box-shadow: 0 -1px 4px rgba(0,0,0,.08); }
.cart-actions > div { display: flex; justify-content: space-between; margin-bottom: 8px; color: #45474b; font-size: 14px; }
.cart-actions strong { color: #ee4d2d; }
.cart-actions button { display: flex; width: 100%; height: 42px; align-items: center; justify-content: center; border: 0; border-radius: 4px; background: #ee4d2d; color: #fff; font-size: 14px; }
.confirm-icon { margin-right: 5px; font-size: 16px; }
.cart-actions button:disabled { background: #d8d8d8; }
.cart-actions a { display: block; padding-top: 14px; color: #45474b; text-align: center; font-size: 14px; }
</style>
